import translateLDSDestinations from "../services/translateLDSDestinations";

const IATA_RE = /^[A-Za-z]{3}$/;

function norm(s) {
  if (s == null) return "";
  const t = String(s).trim();
  if (t === "—" || t === "-") return "";
  return t;
}

/**
 * שורת תצוגה: שם בעברית + קוד IATA בסוגריים (הקוד לא מחליף את השם).
 * @param {string} airportCode - קוד שדה IATA (עדיף) או מזהה לתרגום
 * @param {string} [cityHint] - depCity/arrCity מה-API (יכול להיות קוד או שם)
 * @param {string} [parensIata] - כשמסופק וקוד IATA תקין — תמיד מוצג בסוגריים (מונע "תל אביב (תל אביב)" כש-city הוא שם בעברית)
 * @returns {string}
 */
export function formatEndpointFromCodeAndName(airportCode, cityHint, parensIata) {
  const hint = norm(cityHint);
  const code = norm(airportCode).toUpperCase();
  const forced = norm(parensIata).toUpperCase();
  const validParens = forced && IATA_RE.test(forced) ? forced : "";
  const validCode = code && IATA_RE.test(code) ? code : "";

  let nameHe = "";
  if (validParens) {
    const t = translateLDSDestinations(validParens);
    nameHe = t?.CITYNAME_HEB ? String(t.CITYNAME_HEB).trim() : "";
  }
  if (!nameHe && validCode) {
    const t = translateLDSDestinations(validCode);
    nameHe = t?.CITYNAME_HEB ? String(t.CITYNAME_HEB).trim() : "";
  }
  if (!nameHe && code && !IATA_RE.test(code)) {
    const t = translateLDSDestinations(code);
    nameHe = t?.CITYNAME_HEB ? String(t.CITYNAME_HEB).trim() : "";
  }
  if (!nameHe && hint) {
    const t2 = translateLDSDestinations(hint);
    nameHe = t2?.CITYNAME_HEB ? String(t2.CITYNAME_HEB).trim() : "";
  }
  if (!nameHe && hint && !IATA_RE.test(hint)) {
    nameHe = hint;
  }

  const iata = validParens || validCode || (hint && IATA_RE.test(hint) ? hint.toUpperCase() : "");

  if (nameHe && iata) {
    const nameNorm = nameHe.toUpperCase().replace(/\s/g, "");
    const iataNorm = iata.toUpperCase().replace(/\s/g, "");
    if (nameNorm === iataNorm) return iata;
    return `${nameHe} (${iata})`;
  }
  if (nameHe) return nameHe;
  if (iata) return iata;
  if (hint) return hint;
  return "—";
}

/**
 * מרגל LDS של חבילת נופש (depAirport / depCity וכו')
 * @param {object} leg
 * @param {'dep'|'arr'} side
 */
export function formatPackageLegEndpointHe(leg, side) {
  if (!leg) return "—";
  if (side === "dep") {
    const rawAp = leg.depAirport?.code != null ? String(leg.depAirport.code).trim() : "";
    const parens = IATA_RE.test(rawAp) ? rawAp.toUpperCase() : "";
    const cityField = leg.depCity;
    return formatEndpointFromCodeAndName(parens || cityField, cityField, parens);
  }
  const rawAp = leg.arrAirport?.code != null ? String(leg.arrAirport.code).trim() : "";
  const parens = IATA_RE.test(rawAp) ? rawAp.toUpperCase() : "";
  const cityField = leg.arrCity;
  return formatEndpointFromCodeAndName(parens || cityField, cityField, parens);
}
